<template>
	<div class="p-fluid p-component p-formgrid p-grid p-input-filled">
		<div class="p-field p-col-12">
			<label for="id">{{$t('Squeeze.UserManagement.DocumentClass')}} *</label>
			<Dropdown
				id="id"
				v-model="value.documentClassId"
				:options="documentClasses"
				@change="update"
				:loading="loading"
				optionValue="id"
				:optionLabel="getTranslatedDescription"
			>
			</Dropdown>
			<small v-if="v$.documentClassId.$invalid && showErrorMessage" class="p-error">
				{{ $t('Forms.Val.MissingRequired', { field: $t('Squeeze.UserManagement.DocumentClass')}) }}
			</small>
		</div>
	</div>
</template>

<script lang="ts">
import {getTranslatedDescription} from "@/util/TranslationHelper";
import {defineComponent, nextTick, onMounted, PropType, reactive, ref, watch} from "vue";
import {RoleFilter, DocumentClass} from "@dex/squeeze-client-ts";
import {required} from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import Dropdown from "primevue/dropdown";
import {FormState} from "@/util/Types";

type RoleFilterFormState = FormState<RoleFilter, "documentClassId">;

export default defineComponent({
	name: "FilterListForm",
	components: {
		Dropdown,
	},
	props: {
		filterRole: {
			type: Object as PropType<RoleFilter>,
			required: true,
		},
		documentClasses: {
			type: Array as PropType<DocumentClass[]>,
			required: true,
		},
		showErrorMessage: {
			type: Boolean,
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		const {t} = useI18n();
		const toast = useToast();

		/** Show loading? */
		const loading = ref(false);

		/** Current Object of all input-fields */
		const value = reactive<RoleFilterFormState>({documentClassId: undefined});

		/** Determines the required rules for validation */
		const rules = {
			documentClassId: { required },
		}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(async () => {
			Object.assign(value, props.filterRole);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(props.filterRole, () => {
			Object.assign(value, props.filterRole);
		})

		/** Triggered on change of any field */
		const update = async () => {
			// need nextTick, because the dropdown don't check the change of a selected element (is to slow)
			await nextTick();
			emit("update", value, v$.value.$invalid);
		}

		return {
			getTranslatedDescription,
			t,
			toast,
			loading,
			value,
			props,
			v$,
			update,
		}
	},
});

</script>

<style scoped>

</style>
